import React from 'react';

export default function NoPermissionsTooltip() {
  return <div>You don't have the permissions to perform this action</div>;
}
